import { getApiV2LoyaltyProgramProfile } from '@leroy-merlin-br/backpack-services'

import { requestStore } from 'utils/request-store'

export const storedGetLoyaltyProfile = requestStore(
  getApiV2LoyaltyProgramProfile
)
